import {
  IconWarning24,
  LabeledContent,
} from '@lightspeed/unified-components-helios-theme/react'
import React from 'react'
import {
  AutotaxErrorsProps,
  useAutotaxErrorsModel,
} from './useAutotaxErrorsModel'

export const AutotaxErrors: React.FC<AutotaxErrorsProps> = props => {
  const model = useAutotaxErrorsModel(props)

  if (!model.message) {
    return null
  }

  return (
    <div role="alert" className="uc-base">
      <LabeledContent
        appearance="danger"
        prefixSlot={
          <IconWarning24 aria-hidden className="size-4 fill-current" />
        }
        size="small"
      >
        {model.message}
      </LabeledContent>
    </div>
  )
}
